import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./majorItem.module.scss";
import SonicLink from "../../routing/SonicLink";

type Props = {
  children?: React.ReactNode;
  header: string;
  link?: string;
  icon: React.ReactNode;
  isOpen?: boolean;
  sideBarOpen: boolean;
  handleMenu: () => void;
};

const MajorItem: React.FC<Props> = ({
  children,
  header,
  link,
  icon,
  isOpen,
  sideBarOpen,
  handleMenu,
}) => {
  const aClass =
    isOpen === true
      ? sideBarOpen === true
        ? `${styles["f-majorItem"]} ${styles["show"]}`
        : `${styles["f-majorItem"]} ${styles["hide"]} ${styles["show"]}`
      : sideBarOpen === true
      ? styles["f-majorItem"]
      : `${styles["f-majorItem"]} ${styles["hide"]}`;

  return (
    <li className={aClass}>
      {children ? (
        <>
          <div className={styles["f-majorItem__nameBox"]} onClick={handleMenu}>
            <div className={styles["f-majorItem__nameBox-title"]}>
              {icon}
              <span className={styles["f-majorItem__nameBox-title-header"]}>
                {header}
              </span>
            </div>
            <FontAwesomeIcon
              icon={["fas", "chevron-down"]}
              className={styles["f-majorItem__nameBox-icon"]}
            />
          </div>
          <ul className={styles["f-majorItem__list"]}>{children}</ul>
        </>
      ) : (
        <SonicLink to={link ? link : "/"} onClick={handleMenu}>
          <div className={styles["f-majorItem__nameBox"]}>
            <div className={styles["f-majorItem__nameBox-title"]}>
              {icon}
              <span className={styles["f-majorItem__nameBox-title-header"]}>
                {header}
              </span>
            </div>
          </div>
        </SonicLink>
      )}
    </li>
  );
};

export default MajorItem;
